export default "__VITE_ASSET__o7WZ7R$N__"